type TColors = {
  grayPrimary: string;
  graySecondary: string;
  grayTertiary: string;
};

export const COLORS: TColors = {
  // gray color options
  grayPrimary: '#333',
  graySecondary: '#666',
  grayTertiary: '#999',
};
